import { OPEN_PRODUCT_FORM } from '../actionTypes';
import { actions } from '../reducer';

export default (value) => actions[OPEN_PRODUCT_FORM](value);
